import type { Meeting } from './types'
import { isResponseError } from '@app/utils/predicates'
import SFetch from '@app/utils/sfetch'

export * from './types'

export async function fetchMeetings(): Promise<Meeting[] | null> {
  const url = window.Silverfin.Routes.client_meetings_past_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json<Meeting[]>(url)
}

export const fetchMeeting = SFetch.withRetry<[number], Meeting | null>(
  async (meetingId) => {
    const url = window.Silverfin.Routes.client_meetings_past_meeting_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      meetingId
    )

    return await SFetch.json<Meeting>(url)
  },
  {
    // SFetch reports a failure to reach the server as status 0.
    shouldRetry: (response) =>
      isResponseError(response) &&
      (response.status === 0 || response.status >= 500),
  }
)
